export default __webpack_public_path__ + "static/media/news-map-img.b1b583dc.png";